// extracted by mini-css-extract-plugin
export default {"container":"Nj-z","heading":"Oj-z","items":"Pj-z","action":"Qj-z","disabled":"Rj-z"};